import { baseVendorsUrl, UPDATE_VENDOR_KPI_TYPES_ERROR } from "../../constants";

export const getVendorKPITypesList = async (vendorID) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await fetch(`${baseVendorsUrl}/${vendorID}/kpis`, {
      headers: new Headers({
        "x-access-token": user.accessToken,
        "Content-Type": "application/json",
      }),
    });
    if (!response.ok) throw UPDATE_VENDOR_KPI_TYPES_ERROR;
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    throw UPDATE_VENDOR_KPI_TYPES_ERROR;
  }
};
